<template lang="html">
  <div class="sign-up-group-rule">
    <div class="sign-up-group-rule-l">
      <div>
        {{endTimes}}
      </div>
      <div>
        — 恢复原价 —
      </div>
    </div>
    <div class="sign-up-group-rule-r" @click="openRule">
      <div class="sign-up-group-rule-ctx">
        <p>{{groupSuccessCount}}人成团</p>
        <p>拼团有效期{{duration}}小时</p>
      </div>
    </div>
    <div class="sign-up-group-rule-icon" @click="openRule">
      <img src="../../assets/images/group-rule-icon.png" alt="">
      规则
    </div>
    <!-- <div class="sign-up-group-rule-cover">
     
    </div> -->
    <Notice :closeBtn="closeBtn" ref="notice">
      <div class="sign-up-group-rule-cover-ctx">
        <h1>- 规则公告 -</h1>
        <ul>
          <li>· 邀请好友参团或参与已开团，即享拼团价；</li>
          <li>· 在团有效期内人满则拼团成功，拼团成功后即可进行学习；</li>
          <li>· 在团有效期内未达到拼团人数，则拼团失败，拼团失败后将于1个工作日内自动退款；</li>
        </ul>
      </div>

    </Notice>
  </div>
</template>

<script>
import Notice from '../Notice'
export default {
  name: 'SignUpGroupRule',
  props: ['groupSuccessCount','groupEndDate','groupDuration'],
  data(){
    return {
      closeBtn: true,
      endTimes: "00:00:00",
      timer: ''
    }
  },
  watch: {
    groupEndDate: {
      handler : function (e) {
        this.timer = setInterval(() => {
          if (typeof e === 'number') {
            e -= 1000            
            this.endTimes = this.setDate(e)
          }
        },1000)
      },
      immediate: true,
      // deep:true
    },
  },
  computed: {
    duration() {
      return this.groupDuration/60/60
    }
  },
  methods: {
    openRule() {
      this.$refs.notice.show()
    },
    setDate (date) {
      let hours = parseInt(date/1000/60/60)
      let mins = parseInt((date - hours*1000*60*60) /1000/ 60)
      if (mins < 10) {
        mins = '0' + mins
      }
      let secs = parseInt((date - hours*1000*60*60 - mins*1000*60)/1000)
      if (secs < 10) {
        secs = '0' + secs
      }
      return `${hours}:${mins}:${secs}`
    }
  },
  beforeDestroy () {
    window.clearInterval(this.timer)
  },
  components: {
    Notice
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.sign-up-group-rule {
  &::after {
    content: '';
    display: block;
    clear: both;
  }
  font-weight: bold;
  background: #FFF3DF;
  font-size: rem(24);
  position: relative;
  border-radius: rem(8);
  width: rem(702);
  margin: rem(10) auto;
  overflow: hidden;
  &-l {
    float: left;
    width: rem(274);
    height: rem(110);
    background-image: linear-gradient(-138deg, #FAA761 0%, #F76B1C 100%);
    text-align: center;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    div {
      &:first-child {
        font-size: rem(36);
        margin-bottom: rem(10);
      }
    }
  }
  &-r {
    float: left;    
    box-sizing: border-box;
    padding: rem(22) rem(32);
    padding-bottom: 0;
    color: #F76C1D;
    font-size: rem(28);
    p {
      &:first-child{
        margin-bottom: rem(16);
      }
    }
  }
  &-icon {
    position: absolute;
    top: 50%;
    right: rem(25);
    transform: translateY(-50%);
    font-size: rem(24);
    color: #B3986C;
    img {
      width:rem(26);
    }
  }
  &-cover {

    &-ctx {
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: rem(16);
      h1 {
        font-size: rem(30);
        padding-top: rem(42);
        margin-bottom: rem(38);
      }
      ul {
        color: #999999;
        font-size: rem(28);
        line-height: 1.5;
        text-align: left;
        box-sizing: border-box;
        padding: rem(26) rem(48);
        > li {
          margin-bottom: rem(38);

        }
      }
    }
  }
}
</style>
